// extracted by mini-css-extract-plugin
module.exports = {"logout":"_fB","logout__icon":"_fC","logout__text":"_fD","btns":"_fE","btn":"_fF","btns__logout":"_fG","btns__stay":"_fH"};